module.exports = __webpack_public_path__ + "static/021_001-99fadcda87a77caeb5d10364e9b348d2.jpg";